import * as React from 'react';
import { ServiceSummary } from '../../../features/service-summary';
const TransferExtraCart = ({ onServiceDelete }) => {
    return (React.createElement(ServiceSummary, { serviceType: "Transfer", onDelete: onServiceDelete }, content => content && React.createElement("span", null, content)));
};
export default TransferExtraCart;
